/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/calendar': {
    width: 22,
    height: 20,
    viewBox: '0 0 22 20',
    data: '<path pid="0" d="M5.448 0a.914.914 0 00-.914.914v.899H2.946A2.949 2.949 0 00.001 4.758v4.55L0 16.96a2.949 2.949 0 002.945 2.945H18.53a2.949 2.949 0 002.945-2.945V4.759a2.949 2.949 0 00-2.945-2.945h-1.361v-.9a.914.914 0 00-1.828 0v.899H6.36V.914A.914.914 0 005.449 0zm14.2 16.96c0 .617-.5 1.118-1.117 1.118H2.945c-.616 0-1.117-.5-1.117-1.117V9.308h17.82v7.653zM15.341 3.642v.899a.914.914 0 001.828 0V3.64h1.361c.617 0 1.117.5 1.117 1.117V7.48L1.828 7.48V4.76c0-.617.5-1.118 1.117-1.118h1.588v.899a.914.914 0 001.828 0v-.899l8.98-.001z" _fill="#1B365D"/>'
  }
})
